module.exports = __webpack_public_path__ + "static/img/img8.19a47a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img8.jpg
// module id = ODlz
// module chunks = 1